import * as actions from './savePoint.actions'

export const initialState = {
  currentTurn: 1,
  changingTurn: false,
  settings: {},
  surveyFinished: false,
  surveyScreen: false,
  alertData: null,
}

export const actionsMap = {
  [actions.CHANGE_TURN_FINISH]: (state) => {
    const nextTurn = state.currentTurn + 1
    return {
      ...state,
      currentTurn: nextTurn,
    }
  },

  // Init change turn procedure. Start server communication.
  [actions.CHANGE_TURN_START]: (state) => {
    return {
      ...state,
      changingTurn: true,
    }
  },

  [actions.SET_ALERT_DATA]: (state, action) => {
    return {
      ...state,
      alertData: action.data,
    }
  },
  [actions.REMOVE_ALERT_DATA]: (state) => {
    return {
      ...state,
      alertData: null,
    }
  },
  // Sync settings savePoint
  [actions.SETTINGS_SYNC_SAVEPOINT]: (state, action) => {
    const settings = action.data

    return {
      ...state,
      settings: settings,
    }
  },
  [actions.COMPLETE_SURVEY]: (state) => {
    return {
      ...state,
      surveyFinished: true,
    }
  },
  //
  [actions.TOGGLE_SURVEY]: (state) => {
    return {
      ...state,
      surveyScreen: !state.surveyScreen,
    }
  },
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
